import { useCallback } from "react";
import { useAsync } from "@shared/hooks";
import { eventService } from "@modules/events/services";
import type { Event } from "@/types";
import type { ApiResponse } from "@/types";

/**
 * Hook to fetch the list of events.
 * Handles loading, error, and data states.
 */
export function useEvents() {
  const fetcher = useCallback(
    () =>
      eventService.getEvents().then((res: ApiResponse<Event[]>) => res.data),
    [],
  );

  return useAsync<Event[]>(fetcher);
}
